/**
 * @flow
 * @relayHash 734a210acc721a324bf7fba398d9b522
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEventlessFieldsQueryVariables = {|
  id: string
|};
export type getEventlessFieldsQueryResponse = {|
  +hyevent: {|
    +id: string,
    +title: string,
    +maxNoOfGuests: number,
    +status: string,
    +rsvpedCount: number,
    +startAt: any,
    +endAt: any,
  |}
|};
export type getEventlessFieldsQuery = {|
  variables: getEventlessFieldsQueryVariables,
  response: getEventlessFieldsQueryResponse,
|};
*/


/*
query getEventlessFieldsQuery(
  $id: ID!
) {
  hyevent(id: $id) {
    id
    title
    maxNoOfGuests
    status
    rsvpedCount
    startAt
    endAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "hyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Hyevent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "maxNoOfGuests",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rsvpedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "startAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEventlessFieldsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEventlessFieldsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEventlessFieldsQuery",
    "id": null,
    "text": "query getEventlessFieldsQuery(\n  $id: ID!\n) {\n  hyevent(id: $id) {\n    id\n    title\n    maxNoOfGuests\n    status\n    rsvpedCount\n    startAt\n    endAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b96fe5e0843c069b001c3b1fc253501d';
module.exports = node;
